<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết phiếu yêu cầu</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="handleRouter('/customer-support/assign-order')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
        <button
          v-if="(status === 'WAIT_APPROVED' && hasApprovalPermission) || hasOverduePermission()"
          type="submit"
          class="font-medium f12 btn btn-primary m-r-10"
          @click="handleApprove()"
          :disabled="isLoading"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          Duyệt phiếu
        </button>
        <button
          v-if="(status === 'WAIT_APPROVED' && hasApprovalPermission) || hasOverduePermission()"
          type="submit"
          class="font-medium f12 btn btn-danger m-r-10"
          @click="reject()"
          :disabled="isLoading"
        >
          <b-icon icon="x-lg" aria-hidden="true" />
          Từ chối
        </button>
        <button
          v-if="status === 'WAIT_APPROVED' && hasCancelPermission"
          type="submit"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="handleCancel()"
          :disabled="isLoading"
        >
          <b-icon icon="trash" aria-hidden="true" />
          Huỷ phiếu
        </button>
      </div>
      <hr />
    </div>
    <b-card>
      <b-row class="gx-2">
        <b-col cols="10" md="5">
          <DetailInfo :info="assignOrder" :isLoading="isLoading" :fields="keyNames">
            <template #createdByName="{ value }">
              <span v-if="value"> {{ value }} - {{ getRole(assignOrder?.createdByRole) }} </span>
            </template>
            <template #approvedByName="{ value }">
              <span v-if="value"> {{ value }} - {{ getRole(assignOrder?.approvedByRole) }} </span>
            </template>
            <template #status="{ value }">
              <span v-if="value" :class="`badge ${getStatusClass(value)}`">
                {{ getStatusName(value) }}
              </span>
            </template>
            <template #createdDate="{ value }">
              <span>
                {{ value | formatDate('DD/MM/YYYY HH:mm:ss') }}
              </span>
            </template>
            <template #approvedDate="{ value }">
              <span>
                {{ value | formatDate('DD/MM/YYYY HH:mm:ss') }}
              </span>
            </template>
          </DetailInfo>
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <b-row class="gx-4 px-20">
        <b-col cols="12" class="pl-0">
          <b-card class="shadow-card" title="Bảng danh sách yêu cầu">
            <div class="tab-content" id="nav-tabContent">
              <div class="p-10">
                <div class="mb-1 d-flex align-center">
                  <div class="d-flex align-items-center mb-3">
                    <div>
                      Tổng số yêu cầu:<strong class="text-primary"
                        >&nbsp;{{ tableDataShow.length }}</strong
                      >
                      <span class="mx-2">|</span>
                    </div>
                    <Select2
                      style="min-width: 180px"
                      v-model="assignOrderSuccess"
                      :options="listOrderSuccess"
                      placeholder="Trạng thái"
                      @change="onChangeAssignOrderSuccess"
                    />
                    <div>
                      <span class="mx-2">|</span>
                      <input
                        v-model="txtSearch"
                        type="text"
                        class="input-search d-inline-block"
                        style="width: 200px; height: 25px; text-indent: 5px"
                        placeholder="🔎 Từ khoá"
                      />
                    </div>
                  </div>
                </div>
                <b-table
                  :busy.sync="isLoading"
                  head-variant="light"
                  sticky-header
                  hover
                  responsive
                  :items="tableDataShow"
                  :fields="tableFields"
                  selectable
                  select-mode="single"
                  :fixed="true"
                  :bordered="true"
                >
                  <template #table-busy>
                    <div class="text-center my-2">
                      <b-spinner class="align-middle" />
                    </div>
                  </template>
                  <template #empty>
                    <div class="text-center text-info my-2">Không có dữ liệu</div>
                  </template>
                  <template #cell(index)="data">
                    <div class="font-bold text-primary">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template #cell(merchantCode)="{ item }">
                    <div class="text-primary d-flex mb-1">
                      <img class="mr-1" src="@/assets/img/merchant.svg" alt="" />
                      <span>{{ item.merchantAccount?.accountName }}</span>
                    </div>
                    <div style="margin-left: 20px" class="text-info mb-1">
                      {{ maskSensitiveInfo(item.merchantAccount?.email) }}
                      <i
                        v-if="item.merchantAccount?.email"
                        @click="copyToClipboard(item.merchantAccount?.email)"
                        style="font-size: 16px; margin-left: 5px; color: gray; cursor: pointer"
                        class="bx bxs-copy"
                      ></i>
                    </div>
                    <div class="d-flex">
                      <img class="mr-1" src="@/assets/img/location.svg" alt="" />
                      <span>{{ item.merchantAccount?.businessRegistrationAddress }}</span>
                    </div>
                  </template>
                  <template #cell(store)="{ item }">
                    <div v-for="objKey in keyNamesStore" :key="objKey.key">
                      <div v-if="typeof item.store[objKey.key] !== 'object'" class=" ">
                        <div class="">
                          <span>
                            <span v-if="objKey.key === 'address'">
                              {{ getAdressByCode(item.store) }}
                            </span>

                            <div v-else-if="objKey.key === 'storeName'" class="action_class">
                              <b-link
                                :href="`/customer-support/store/${item.store.id}`"
                                target="_blank"
                              >
                                {{ item.store.storeName ?? item.store.email }}
                              </b-link>
                            </div>

                            <div v-else-if="objKey.key === 'location'">
                              <div
                                v-if="
                                  (item?.store?.latitude && item?.store?.longtitude) ||
                                  item?.store?.address
                                "
                                class="action_class"
                              >
                                <b-icon icon="geo-alt"></b-icon>
                                <strong
                                  class="text-primary"
                                  style="cursor: pointer"
                                  @click="
                                    showMapModal(
                                      item.store.latitude,
                                      item.store.longtitude,
                                      getAdressByCode(item.store)
                                    )
                                  "
                                >
                                  {{ item.store.address }}
                                </strong>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(currentStaffAssigns)="{ item }">
                    <staff-assign
                      :item="item.currentStaffAssigns"
                      :type="'configType'"
                    ></staff-assign>
                  </template>
                  <template #cell(orderStaffAssigns)="{ item }">
                    <staff-assign
                      :item="item.orderStaffAssigns"
                      :type="'assignType'"
                    ></staff-assign>
                  </template>
                  <template #cell(errorMessage)="{ item }">
                    <div v-if="!item.assignOrderSuccess">
                      {{ item.errorMessage }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-scoped" v-model="showModal" @hide="handleCloseReject">
      <template #modal-header="{ close }">
        <h5>Bạn chắc chắn muốn từ chối phiếu yêu cầu ?</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="">
        <p class="f14 pb-2">Lý do từ chối yêu cầu</p>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleReject)">
            <ValidationProvider rules="required|minMaxName_4" name="Lý do" v-slot="{ errors }">
              <b-form-group label="" label-for="floatingTextarea2">
                <b-form-textarea
                  id="floatingTextarea2"
                  v-model="reason"
                  placeholder="Lý do"
                  rows="3"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="input-live-feedback">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Huỷ bỏ </b-button>
        <b-button size="sm" variant="primary" @click="handleReject"> Đồng ý </b-button>
      </template>
    </b-modal>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longtitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal ref="map-address" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <iframe loading="lazy" :src="url" height="500" style="width: 100%" frameborder="0"></iframe>
      </div>
    </b-modal>
    <VueLoadingOverlay :active.sync="fcLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { Approve, Cancel, Detail, Overdue } from '@/services/customer-support/assign_order'
  import { showMess } from '@/config/utils'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import { CommonService } from '@/services/common.service'
  import { MaRole } from '@/constant/customerSupport'
  import moment from 'moment'
  import StaffAssign from '@/components/cskh/StaffAssign.vue'

  export default {
    components: {
      StaffAssign,
      DetailInfo,
    },
    data() {
      return {
        latitude: 0.0,
        longtitude: 0.0,
        url: '',
        MaRole,
        isLoading: false,
        fcLoading: false,
        id: '',
        status: '',
        assignOrder: null,
        assignOrderSuccess: '1',
        listOrderSuccess: [
          { id: '0', text: 'Tất cả' },
          { id: '1', text: 'MC tạo phiếu thành công' },
          { id: '2', text: 'MC tạo phiếu thất bại' },
        ],
        keyNames: [],
        keyNamesStore: [
          { key: 'storeName', label: '' },
          { key: 'address', label: '' },
          { key: 'location', label: '' },
        ],
        listStatus: [],
        listStatusStore: [],
        txtSearch: '',
        reason: '',
        option: '',
        showModal: false,
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        tableFields: [
          { key: 'index', label: 'STT' },
          { key: 'merchantCode', label: 'Thông tin Merchant' },
          { key: 'currentStaffAssigns', label: 'Nhân viên chăm sóc hiện tại' },
          { key: 'orderStaffAssigns', label: 'Nhân viên chăm sóc cần cập nhật' },
        ],
        assignInfos: [],
      }
    },

    filters: {},

    async created() {
      this.id = this.$router.currentRoute.params.id
      await this.configSystem()
      await this.loadData()

      this.keyNames = [
        { key: 'orderCode', label: 'Mã phiếu' },
        { key: 'createdByName', label: 'Người tạo' },
        {
          key: 'approvedByName',
          label: 'Người ' + this.getStatusTag(this.status),
        },
        { key: 'status', label: 'Trạng thái' },
        { key: 'createdDate', label: 'Thời gian tạo' },
        {
          key: 'approvedDate',
          label: 'Thời gian ' + this.getStatusTag(this.status),
        },
      ]

      if (this.assignOrder.levelAssign === 'STORE') {
        this.tableFields.splice(1, 0, { key: 'store', label: 'Cửa hàng' })
      }
    },

    computed: {
      hasCancelPermission() {
        const userId = JSON.parse(localStorage.getItem('userData'))?.userId
        return userId === this.assignOrder?.createdBy
      },
      hasApprovalPermission() {
        return this.dataPermission.includes('CNPS_CSS_ASSIGN_ORDER_APPROVE')
      },
      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusStore() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      tableDataShow() {
        const txt = this.txtSearch.trim().toLocaleLowerCase()

        // filter with both txt and assignOrderSuccess = 0 is all, and 1 is true, 2 is false
        const data = this.assignInfos
          .filter(item => {
            if (this.assignOrderSuccess === '0') {
              return true
            }
            return this.assignOrderSuccess === '1'
              ? item.assignOrderSuccess
              : !item.assignOrderSuccess
          })
          .filter(
            item =>
              (item.merchantAccount?.email || '').toLocaleLowerCase().indexOf(txt) >= 0 ||
              (item.merchantAccount?.accountName || '').toLocaleLowerCase().indexOf(txt) >= 0
          )

        if (data.some(item => !item.assignOrderSuccess)) {
          this.addErrorField()
        } else {
          this.removeErrorField()
        }

        return data
      },
    },

    methods: {
      copyToClipboard(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            showMess(
              this,
              'Success',
              'Sao chép thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
          .catch(err => {
            console.error('Lỗi khi sao chép: ', err)
            showMess(
              this,
              'Error',
              'Lỗi khi sao chép: ' + err,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
      },
      maskSensitiveInfo(input) {
        if (input.includes('@')) {
          return input.replace(/(.{2}).+(@.+)/, '$1****$2')
        } else if (/^(\d{10})$/.test(input) || /(\d{2,3})\d{4}(\d{3,4})/.test(input)) {
          return input.replace(/(\d{2,3})\d{4}(\d{3,4})/, '$1****$2')
        } else {
          return input.replace(/(.{3}).+(.{3})/, '$1****$2')
        }
      },
      showMapModal(lat, long, address) {
        if (lat && long) {
          this.latitude = Number.isInteger(this.latitude) ? lat : parseFloat(lat)
          this.longtitude = Number.isInteger(this.longtitude) ? long : parseFloat(long)
          this.$refs['modal-map'].show()
        } else {
          this.url = `https://maps.google.com/maps?q=${address}&output=embed`
          this.$refs['map-address'].show()
        }
      },
      hasOverduePermission() {
        return (
          this.dataPermission.includes('CNPS_CSS_ASSIGN_ORDER_APPROVE_OVERDUE') &&
          this.status === 'OVERDUE'
        )
      },
      getStatusTag(status) {
        return status === 'REJECTED' ? 'từ chối' : status === 'CANCELED' ? 'huỷ' : 'duyệt'
      },
      handleRouter(route) {
        this.$router.push(route)
      },
      handleBack() {
        this.handleRouter('/customer-support/assign-order')
      },
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.loadData()
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)
          this.assignOrder = res.data.assignOrder
          this.status = res.data.assignOrder?.status

          if (this.status === 'REJECTED') {
            this.keyNames.splice(4, 0, { key: 'reason', label: 'Lý do' })
          }

          this.assignInfos = res.data.assignInfos
          this.pagination.total = res.data.assignInfos?.length
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      formatDate(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
      formatHour(date) {
        if (!date) return
        return moment(date).format('HH:mm')
      },
      handleApprove() {
        const modal = this.approveMx('Bạn chắc chắn muốn duyệt phiếu yêu cầu ?')
        modal.then(async close => {
          if (close) {
            await this.sendApprove('APPROVED')
            // this.handleBack()
          }
        })
      },
      async handleReject() {
        // validate reason
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return
        this.showModal = false
        await this.sendApprove('REJECTED')
        // this.handleBack()
      },
      handleCloseReject() {
        this.reason = ''
      },
      async sendApprove(status) {
        try {
          this.fcLoading = true
          let res = null
          if (this.hasOverduePermission()) {
            res = await Overdue({
              orderId: this.id,
              status: status,
              reason: this.reason,
            })
          } else {
            res = await Approve({
              orderId: this.id,
              status: status,
              action: status,
              reason: this.reason,
            })
          }
          this.fcLoading = false
          this.handleShowMessage(res)
        } catch (e) {
          this.fcLoading = false
          this.showToastError(e.message)
        }
      },
      reject() {
        this.showModal = true
      },
      handleCancel() {
        const modal = this.approveMx('Bạn chắc chắn muốn huỷ phiếu yêu cầu ?')
        modal.then(async close => {
          if (close) {
            try {
              this.fcLoading = true
              let res
              if (this.hasOverduePermission()) {
                res = await Overdue({
                  orderId: this.id,
                  status: 'CANCELED',
                  reason: '',
                })
              } else {
                res = await Cancel(this.id)
              }
              this.handleShowMessage(res)
              // this.handleBack()
            } catch (e) {
              this.showToastError(e.message)
            } finally {
              this.fcLoading = false
            }
          }
        })
      },
      handleShowMessage(res) {
        if (res.code === 1000) {
          const modal = this.showSuccessMx(res.message)
          modal.then(() => {
            this.handleBack()
          })
        } else {
          const modal = this.showFailMx(res.message)
          modal.then(() => {
            this.handleBack()
          })
        }
      },
      getAdressByCode(item) {
        const addressArr = []
        if (item.districtName) {
          addressArr.push(item.districtName)
        }
        if (item.provinceName) {
          addressArr.push(item.provinceName)
        }
        if (item.regionName) {
          addressArr.push(item.regionName)
        }
        return addressArr.length > 0 ? addressArr.join(', ') : item.address
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.listStatus = data.data.assignOrderStatus.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                  name: item.name,
                  bgColor: item.bgColor,
                  class: item?.class ?? 'text-primary',
                }
              })

              this.listStatusStore = data.data.storeStatus.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  bgColor: e.bgColor,
                  class: e?.class ?? 'text-primary',
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
      getRole(role) {
        const objRole = this.MaRole.find(s => s.id === role)
        return objRole ? objRole.text : role
      },
      onChangeAssignOrderSuccess(val) {
        // if (val === '2' || val === '0') {
        //   this.tableFields.push({ key: 'errorMessage', label: 'Lỗi' })
        // } else {
        //   this.tableFields = this.tableFields.filter(
        //     (item) => item.key !== 'errorMessage'
        //   )
        // }
      },
      addErrorField() {
        this.tableFields.push({ key: 'errorMessage', label: 'Lỗi' })
      },
      removeErrorField() {
        this.tableFields = this.tableFields.filter(item => item.key !== 'errorMessage')
      },
    },
  }
</script>

<style scoped>
  ul.report-preview {
    padding-left: 0;
    display: flex;

    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      width: 100px;
      min-width: 100px;
      height: 60px;
      cursor: pointer;
      /* text-align: center; */
      padding: 10px;

      &:hover {
        color: #f00;
        font-weight: 500;
      }

      .label {
        font-size: 14px;
        text-align: center;
      }

      .value {
        text-align: center;
        margin-top: 2px;
        font-size: 16px;
        font-weight: 600;
      }

      & + li {
        margin-left: 10px;
      }
    }
  }

  h1 {
    border-bottom: none;
  }

  .text-green {
    color: #009235;
  }

  .input-search {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px dotted #999;
    border-radius: 0;
    padding: 0;
    margin: 0;
  }
</style>
